module.exports = __webpack_public_path__ + "static/img/22144C_1_2_C_20240427_LC.1584974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/22144C_1_2_C_20240427_LC.png
// module id = 87NF
// module chunks = 0